export default "__VITE_ASSET__CJLPdxbt__"